import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import ManualBookingForm from '../../containers/bookings/ManualBookingForm';


const propTypes = {
    visible: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
};

const AdminAddHolidayModal = ({ visible, handleCancel }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(visible);
    }, [visible]);

    return (
        <Modal
            title={null}
            visible={isVisible}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose
        >
            <ManualBookingForm handleCancel={handleCancel} />
        </Modal>
    );
};

AdminAddHolidayModal.propTypes = propTypes;

export default AdminAddHolidayModal;
